import React, { useContext, useEffect } from "react";
import { CartContext } from "../cart/ContextProvider";
import "./orderItems.css";
import OrderBreadCrum from "./orderBreadCrum";
import ReceiptIcon from '@mui/icons-material/Receipt';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import NorthEastIcon from '@mui/icons-material/NorthEast';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import { useLocation } from 'react-router-dom';


function OrderItems() {
    const { orderItems, fetchOrderItems } = useContext(CartContext)
    const location = useLocation();
  const order = location.state;

  useEffect(() => {
    
    fetchOrderItems(order.items);
  }, [order]);
    
   

        let total=0,tax = 0;
        orderItems.map((item, id) =>{
                total = total + (item.price*item.qty);
        })
        tax = 0.05 * total;



    return <div>
        <OrderBreadCrum order={order} />
        <div className="order-id">
            <p className="heading">Order Id: {order.id}</p>
            <div className="button">
                <ReceiptIcon fontSize="small" />
                <p >Invoice</p>
            </div>

        </div>

        {/* <p>Order date: {order.order_date}</p> */}

        <hr></hr>

        <div className="content">
            {orderItems.length > 0 ?
                orderItems.map((item, id) => (
                    <div className="item-container" key={id}>
                        <div className="row">
                            <div className="img-div"><img className="item-img" src={item.image} alt={item.name} /> </div>
                            <div className="itemDetails">
                                <p className="itemName">{item.name}</p>
                                <p className="itemBrand">{item.brand}</p>
                                <p className="itemQty">Qty: {item.qty}</p>
                                <p className="itemPrice">&#8377; {Math.floor(item.price*item.qty)}</p>
                                
                            </div>
                        </div>
                    </div>
                )) : (
                    <div>
                        <p>No Items found Check later</p>
                    </div>
                )
            }
        </div>


        <hr></hr>
        <div className="center">
            <div className="order-bottom">

                <div className="help">
                    <h6>Need Help ?</h6>
                    <p><HelpCenterIcon color="disabled"></HelpCenterIcon> Order Issues <NorthEastIcon color="disabled"></NorthEastIcon></p>
                    <p><LocalShippingIcon color="disabled"></LocalShippingIcon> Delivery Info <NorthEastIcon color="disabled"></NorthEastIcon></p>
                    <p><AssignmentReturnIcon color="disabled"></AssignmentReturnIcon> Returns <NorthEastIcon color="disabled"></NorthEastIcon></p>
                </div>


                <div className="summary">
                    <h3>Order Summary</h3>
                    <div>
                        <div className="sub-total">
                            <h4 className="label">Subtotal</h4>
                            <h4 className="amount">&#8377; {Math.floor(total)}</h4>
                        </div>
                        <div className="delivery">
                            <h6 className="label">Delivery</h6>
                            <h6 className="amount">&#8377; 0</h6>
                        </div>
                        <div className="tax">
                            <h6 className="label">Tax</h6>
                            <h6 className="amount">&#8377; {Math.floor(tax)}</h6>
                        </div>
                        <hr></hr>
                        <div className="total">
                            <h5>Total</h5>
                            <h5 className="amount">&#8377; {Math.floor(total + tax)}</h5>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
}

export default OrderItems;